import { render, staticRenderFns } from "./zxks_dtlx.vue?vue&type=template&id=7581935c&scoped=true&"
import script from "./zxks_dtlx.vue?vue&type=script&lang=js&"
export * from "./zxks_dtlx.vue?vue&type=script&lang=js&"
import style0 from "./zxks_dtlx.vue?vue&type=style&index=0&id=7581935c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7581935c",
  null
  
)

export default component.exports